/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './IraOverContribution.scss';

import { bool, func } from 'prop-types';
import React from 'react';

import Disclosure from 'components/shared/Disclosure/Disclosure';
import Content from 'services/Content';
import { AAMBeaconControl, AAMBeaconControlGroup } from "../../../shared/Beacon";

const IraOverContribution = ({ isChecked, onChange }) => (
    <div className="ira-over-contribution">
        <Disclosure content={Content.iraOverContributionCopy} />
        <div className="ira-checkbox-wrapper">
            <div className="beacon-on-light">
                <AAMBeaconControlGroup>
                    <AAMBeaconControl inline>
                        <input type="checkbox"
                            onChange={() => onChange(!isChecked)}
                            checked={isChecked}
                            disabled={false}
                            required={true}
                            id="auto-buy-opt-out" />
                    </AAMBeaconControl>
                </AAMBeaconControlGroup>
            </div>
            <div className={'ira-checkbox-copy'}>
                <Disclosure content={Content.iraCheckboxCopy} />
            </div>
        </div>
    </div>
);

IraOverContribution.propTypes = {
    isChecked: bool.isRequired,
    onChange: func.isRequired
};

export default IraOverContribution;
